import React from 'react'

const Contact = () => {
  const contactInfo = [
    {
      icon: 'fas fa-clock',
      title: 'ساعات کاری',
      content: 'شنبه تا پنجشنبه : ۹ صبح تا ۸ شب'
    },
    {
      icon: 'fas fa-map-marker-alt',
      title: 'محل تدریس',
      content: 'گرگان - مطهری - کلاس‌های آنلاین و حضوری'
    },
    {
      icon: 'fas fa-envelope',
      title: 'ایمیل',
      content: 'somayearbab44@gmail.com',
      isEmail: true
    }
  ]

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">تماس با من</h2>
        <div className="contact-content">
          <div className="contact-info">
            <h3>اطلاعات</h3>
            {contactInfo.map((info, index) => (
              <div key={index} className="contact-item card-base card-light-sweep card-overlay">
                <i className={info.icon} aria-hidden="true"></i>
                <div>
                  <h4>{info.title}</h4>
                  {info.isEmail ? (
                    <p>
                      <a href={`mailto:${info.content}`}>{info.content}</a>
                    </p>
                  ) : (
                    <p>{info.content}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="contact-image">
            <div className="contact-placeholder">
              <i className="fas fa-phone-alt" aria-hidden="true"></i>
            </div>
            <div className="contact-text">
              <h3>آماده پاسخگویی</h3>
              <p>برای مشاوره و ثبت‌نام در کلاس‌ها، از طریق یکی از روش‌های پایین با من تماس بگیرید.</p>
              <div className="contact-buttons">
                <a 
                  href="https://t.me/somayeham1360" 
                  className="btn btn-primary" 
                  target="_blank" 
                  rel="noopener"
                >
                  <i className="fab fa-telegram" aria-hidden="true"></i>
                  پیام در تلگرام
                </a>
                <a 
                  href="https://wa.me/09118699453" 
                  className="btn btn-secondary" 
                  target="_blank" 
                  rel="noopener"
                >
                  <i className="fab fa-whatsapp" aria-hidden="true"></i>
                  پیام در واتساپ
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact 